import * as React from 'react';
import { useState } from 'react';
import styled, { css } from 'styled-components';
import { langAll, langWord } from 'locales';


const Wrap = styled.ul`
  position: absolute;
  top: 10px; left: 25px;
  z-index: 100;
`;

const btnStyle = css`
  display: inline-block;
  padding: 0 5px;
  height: 24px;
  line-height: 22px;
  font-size: 12px;
  border: 1px solid #a8988a;
  border-radius: 10px;
  background: #fff;
  vertical-align: top;
`;

interface StyleProps {
  active: boolean;
}

const activeClass = css`
  color: #fff;
  background: #a8988a;
`;

const LangBtn = styled.button<StyleProps>`
  ${btnStyle}
  ${props => props.active && activeClass}
`;

const LangAtag = styled.a<StyleProps>`
  margin-left: 5px;
  ${btnStyle}
  ${props => props.active ? 'display: inline-block;' : 'display: none'}
`;

interface IProps {
  messages?: any;
  lang?: string;
}


const Lang = ({lang}: IProps) => {
  const [langView, setLang] = useState(false);
  const activeLang = langWord[langAll.filter((item, index) => item === lang)[0]];

  return (
    <Wrap>
      <LangBtn type="button" active={langView} onClick={() => setLang(!langView)}>{activeLang}</LangBtn>
      {
        langAll.map((item, index) => (
          activeLang !== langWord[item] && <LangAtag href={'/' + item} key={index} active={langView}>{langWord[item]}</LangAtag>
        ))
      }
    </Wrap>
  );
};

export default Lang;



// WEBPACK FOOTER //
// ./src/components/intro/lang.tsx